export default __webpack_public_path__ + "static/media/blog-banner.f355f6d8.webp";